import container from "../../libs/container/container";
import sliderListFactory from "../../libs/slider/slider-list";

const amdHowToSellStepsModule = (function () {
    const name = 'how-to-sell__steps-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        const sliderListNewCustomer = sliderListFactory.create();
        sliderListNewCustomer.init(view.publicVars.sliderListNewCustomerConfig);

        const sliderListExistingQr = sliderListFactory.create();
        sliderListExistingQr.init(view.publicVars.sliderListExistingQrConfig);

        const sliderListExistingWifi = sliderListFactory.create();
        sliderListExistingWifi.init(view.publicVars.sliderListExistingWifiConfig);
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHowToSellStepsModule;